<template>
  <div v-if="hasImageNotFound" style="position: absolute; top: 0;left: 0; right: 0; bottom: 0; z-index: 10000;" @click="handleHasImageNotFound"></div>
  <!-- Desktop工具列 -->
  <ToolPanel v-if="!desktopSaveMode" :features="features" :cancelActiveObj="cancelActiveObj" :isLoadingImage="loadingImage" @clearCanvas="clearCanvas">
    <template v-if="featureData.featureId && featureData.showInPanel" #featurePanel>
      <div style="height: 100%; overflow-y: auto;">
        <component :is="currentComponent" v-bind="componentsParams[componentName]"></component>
      </div>
    </template>
  </ToolPanel>
  <component v-if="featureData.featureId && !featureData.showInPanel" :is="currentComponent" v-bind="componentsParams[componentName]"></component>

  <!-- 讀取資料和設定DesignLab時顯示的spinner -->
  <div class="dl-spinner-wrap">
    <div class="mk-spinner" v-if="designLabStore.designLabLoading"></div>
  </div>

  <div id="right-block" :class="{'save-mode': desktopSaveMode,'dl-loading': designLabStore.isDesignLabLoading}">
    <!-- Mobile操作按鈕 -->
    <div class="top-toolbar">
      <div class="d-flex align-items-center" style="gap: 1rem">
        <img :src="GetImageUrl('tools/switch_area.png')" alt="更改區域" width="35" @click="showAreaToggle" style="cursor: pointer;">
        <button class="step-btn" @click="undo()"><img :src="GetImageUrl('tools/redo.png')" alt="上一步"></button>
        <button class="step-btn" @click="redo()"><img :src="GetImageUrl('tools/undo.png')" alt="下一步"></button>
      </div>
      <button
        class="submit-btn" @click="desktopSubmit()" :disabled="designLabStore.isIniting">提交</button>
    </div>

    <div ref="areaBlock" v-if="showAreaOptions" class="area-block">
      <div :class="area.title == currentProductArea ? `${areaOptionClass} active` : `${areaOptionClass}`" v-for="area in ProductAreas" :key="area" @click="changeArea(area.title)">
        <img :src="area.image_url" alt="" width="30">
        <span>{{ area.title }}</span>
      </div>
    </div>
    <div v-if="!desktopSaveMode && stepArray.length > 1" class="RedoUndo-Toolbar">
      <button class="step-btn" style="border-radius: 5px 5px 0 0;" :disabled="stepIndex == 0" @click="undo()"><img :src="GetImageUrl('tools/redo.png')" alt="上一步" title="undo"></button>
      <button class="step-btn" style="border-radius: 0 0 5px 5px;" :disabled="stepArray.length && stepIndex == stepArray.length - 1" @click="redo()"><img :src="GetImageUrl('tools/undo.png')" alt="下一步" title="redo"></button>
    </div>

    <!-- 設計區域 -->
    <div class="d-flex position-relative" id="canvas_block">
      <div v-if="hasFocusedInput" style="position: absolute; top: 0;left: 0; right: 0; bottom: 0; z-index: 10000;"></div>
      <canvas id="canvas"></canvas>
    </div>

    <!-- Desktop操作按鈕 -->
    <div v-if="!desktopSaveMode" class="product-title">
      <span>{{ ProductInfo.title }}</span>
      <div class="desktop-submit-block">
        <button class="mk-btn dl-desktop-submit-btn" @click="desktopSubmit(true)" :disabled="designLabStore.isIniting">
          <span>提交</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Desktop選擇區域選單 -->
  <div v-if="!desktopSaveMode" class="desktop-area-block" :class="{'dl-loading': designLabStore.isDesignLabLoading}">
    <div :class="area.title == currentProductArea ? `${areaOptionClass} active` : `${areaOptionClass}`" v-for="area in ProductAreas" :key="area" @click="changeArea(area.title)">
      <img :src="area.image_url" alt="" width="40">
      <span>{{ area.title }}</span>
    </div>
  </div>

  <!-- Desktop Setup -->
  <Transition name="saveBlock">
    <div id="saveBlock" v-if="desktopSaveMode">
      <!--  -->
      <component :is="stepComponents[designLabStore.activeSetupName]" :desktopMode="true"></component>
    </div>
  </Transition>

  <!-- Setup components -->
  <component :is="stepComponents[designLabStore.activeSetupName]" v-if="!desktopSaveMode"></component>

  <!-- restore design button -->
  <div class="dl-toast-wrap" v-if="designLabStore.showRestoreDesignBtn">
    <div class="dl-toast">
      <div class="dl-toast-content">
        <span>是否恢復先前版本?</span>
        <div class="mk-btn ms-2" @click="designLabStore.restoreDesignByCache()">恢復</div>
        <button type="button" class="btn-close btn-close-white dl-toast-btn-close" @click="designLabStore.clearDesignCache()"></button>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, reactive, onMounted, watch, computed, onUnmounted, defineProps } from 'vue'
  import { fabric } from 'fabric'
  import apiData from './data.json'
  import {GetImageUrl} from "@/javascripts/utils.js";
  import ToolPanel from '@/vues/components/ToolPanel.vue'
  import ChangeProductModal from '@/vues/components/ChangeProductModal.vue'
  import AddModule from '@/vues/components/AddModule.vue'
  import UploadImage from '@/vues/components/UploadImage.vue'
  import AddText from '@/vues/components/AddText.vue'
  import ProductColor from "@/vues/components/ProductColor.vue"
  import { features, featureData, isMobile, initFeatureObj, setFeatureData, changeFeature, changeIsMobile, changeMaxWidth, isTextType, isVerticalText, isValidTextImage, isValidVerticalTextImage, getTextImage, getVerticalTextImage, getModule, moduleColorLock, panelOperationEvent, hasFocusedInput } from "@/vues/utils/feature.js"
  import swal from "sweetalert";

  const props = defineProps([
    "designId", // edit傳進來的design ID
    "designMode", // 判定初始前往design哪個mode
    "designVgId",
    "designMaterialId"
  ]);

  // setup component
  // 若有增加setup component的話或調整順序的話
  // designLabStore.setups也需要修改
  import DesignCheck from  "../components/setups/DesignCheck.vue"
  import DesignName from "../components/setups/DesignName.vue"
  import DesignShare  from "../components/setups/DesignShare.vue"
  import DesignShoppingCart  from "../components/setups/DesignShoppingCart.vue"
  import {Debounce} from "~/javascripts/common.js";
  const stepComponents = {DesignCheck, DesignName, DesignShare ,DesignShoppingCart };

  import {useDesignLabStore} from "../components/DesignLabStore.js"
  import {storeToRefs} from 'pinia'
import { write } from '@popperjs/core';
  const designLabStore = useDesignLabStore();
  const {design, originalDesignAreas, canvasObjsCache, desktopSaveMode, specColors} = storeToRefs(designLabStore);

  // design主要資料
  const ProductInfo = design;
  const tmpCanvasObjs = canvasObjsCache.value;

  const pendingFlip = ref(null);
  const pendingSpacing = ref(null);
  const isSpecialResize = ref(false);
  const showAreaOptions = ref(false)
  const screenWidth = ref(document.body.clientWidth)
  const screenHeight = ref(document.body.clientHeight)
  const rato = ref(0)
  var center = reactive({}) //畫布中心點預設(397.5, 623.5)為基準
  var canvas //在外層宣告canvas以便全域都能吃到(watch會用到)
  const currentProductArea = ref("")
  const currentProductAreaInfo = computed(() => ProductInfo.value.moks.find(x => x.title == currentProductArea.value))
  const ProductAreas = computed(() => ProductInfo.value.moks.map(x => { return {title: x.title, image_url: x.image_url}}))
  // const tmpCanvasObjs = reactive({}) //用來記錄當前畫布上的物件，方便在resize canvas或切換區域時重建obj
  const loadingImage = ref(false)
  const hasImageNotFound = ref(false) // text在過小（小於144）的畫布作圖可能造成 image not found, 如果有, 禁止change area,undo, redo, submit
  const areaOptionClass = computed(() => loadingImage.value ? 'loading' : '')
  const areaBlock = ref()
  const reserveProps = ['id', 'image_id', 'imageWidth', 'imageHeight', 'design_type', 'text', 'textColor', 'font_family', 'imageColors', 'bound', "boundWidthCm", "boundHeightCm", "letter_spacing"]
  const components = {
    ChangeProductModal,
    AddModule,
    UploadImage,
    AddText,
    ProductColor
  }
  const componentName = ref();
  const currentComponent = computed(() => components[componentName.value]);
  const componentsParams = computed(() => {
    return {
      ChangeProductModal: {},
      AddModule: {},
      UploadImage: {},
      AddText: {},
      ProductColor: {colors: specColors.value }
    }
  })

  //抓產品邊界的資訊
  let getProductLimitInfo = () => {
    // Object.assign(ProductInfo.value, apiData.design)
    specColors.value = specColors.value;
    setFeatureData('variantId', ProductInfo.value.variant_id)
    currentProductArea.value = ProductAreas.value[0].title
    ProductInfo.value.moks.forEach(mok => {
      tmpCanvasObjs[mok.title] = {
        firstCreate:   true,              //是否第一次建立
        areaObjs:      mok.areas,         //邊界物件
        designObjs:    mok.designs,       //設計物件
        center:        mok.center,        //畫布中心
        maxHeight:     mok.max_height,    //畫布高度
        stepArray: [{                     //暫存歷史紀錄，redo、undo功能
          designObjs:  mok.designs,
          center:      mok.center,
          maxHeight:   mok.max_height,
        }],
        stepIndex: 0
      }
    });
  }

  const stepArray = computed(() => {
    return tmpCanvasObjs[currentProductArea.value] ? tmpCanvasObjs[currentProductArea.value].stepArray : []
  })
  const stepIndex = computed(() => tmpCanvasObjs[currentProductArea.value] ? tmpCanvasObjs[currentProductArea.value].stepIndex : 0 )

  const closeAreaBlock = (e) => {
    if (areaBlock.value && !areaBlock.value.contains(e.target)) {
      showAreaOptions.value = false;
    }
  }

  const showAreaToggle = (e) => {
    showAreaOptions.value = !showAreaOptions.value
    e.stopPropagation()
  }

  const init = () => {
    // var hhh = document.querySelector('.header').offsetHeight
    // document.querySelector('#design-lab').style.setProperty('height', `calc(100vh - ${hhh}px)`);

    //在初始化，onMounted的時候建立畫布
    canvas = new fabric.Canvas('canvas', {
      uniformScaling: true,
      backgroundColor: '#f5f5f5'
    })

    //設定corner control顯示與否
    fabric.Object.prototype.setControlsVisibility({
      bl: false, // 左下
      br: true, // 右下
      mb: false, // 下中
      ml: false, // 中左
      mr: false, // 中右
      mt: false, // 上中
      tl: false, // 上左
      tr: false, // 上右
      mtr: true // 旋轉控制鍵
    })

    fabric.Object.prototype.set({
      cornerColor: "blue",
      borderColor: "#000",
      borderDashArray: [5],
    })

    const originalToObject = fabric.Object.prototype.toObject;
    fabric.Object.prototype.toObject = function(propertiesToInclude) {
      // 調用原始 toObject 方法並獲取對象
      const obj = originalToObject.call(this, propertiesToInclude);

      // 手動設置想要保留的小數位數(完整保存)
      obj.scaleX = parseFloat(this.scaleX.toFixed(16));
      obj.scaleY = parseFloat(this.scaleY.toFixed(16));

      return obj;
    };

    addDeleteControl()
    changeControlIcon()
    canvas.on({
      'selection:created':handleSelection,
      'selection:updated':handleSelection
    });

    canvas.on('selection:cleared', () => {
      // 沒有任何物件被選取時的處理邏輯
      initFeatureObj('activeObj') //清空選擇的canvas物件info
      setFeatureData('featureId', NaN)
    });

    canvas.on('mouse:down', function(options) {
      if (options.e.shiftKey) {
        // 如果按下 Shift 键，取消多选
        canvas.discardActiveObject();
      }
    });
  }

  //新增刪除canvas obj的控制按紐
  const addDeleteControl = () => {
    fabric.Object.prototype.controls.deleteControl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: -10,
      offsetY: -10,
      cursorStyle: 'pointer',
      mouseUpHandler: deleteObject,
      render: renderIcon,
      cornerSize: 20
    });

    var img = new Image
    img.src = "https://printverse-resources.s3-us-west-1.amazonaws.com/delete-icon.png"

    function deleteObject(eventData, transform) {
      var target = transform.target;
      canvas.remove(target);
      canvas.requestRenderAll();
      updateCanvasObjsInfo()
      setStepInfo()
      designLabStore.notifyDesignChanged()
    }

    function renderIcon(ctx, left, top, styleOverride, fabricObject) {
      var size = this.cornerSize;
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(img, -size/2, -size/2, size, size);
      ctx.restore();
    }

  }

  //改變canvas Obj控制按鈕的圖案
  const changeControlIcon = () => {
    var rotateImg = new Image
    rotateImg.src = GetImageUrl('examples/rotate_icon.png')

    fabric.Object.prototype.controls.mtr.render = function(ctx, left, top, styleOverride, fabricObject) {
      var size = 20;   //要設定size大小，圖片才會顯示
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(rotateImg, -size/2, -size/2, size, size);
      ctx.restore();
    };

    var scaleImg = new Image
    scaleImg.src = GetImageUrl('examples/scale.png')

    fabric.Object.prototype.controls.br.offsetX = 10
    fabric.Object.prototype.controls.br.offsetY = 10
    fabric.Object.prototype.controls.br.render = function(ctx, left, top, styleOverride, fabricObject) {
      var size = 20;   //要設定size大小，圖片才會顯示
      ctx.save();
      ctx.translate(left, top);
      ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
      ctx.drawImage(scaleImg, -size/2, -size/2, size, size);
      ctx.restore();
    };
  }


  const handleSelection = (e) => {
    //防止多選
    if(e.selected.length > 1) {
      canvas.discardActiveObject();
      canvas.requestRenderAll();
      return;
    }
    var selectedObject = canvas.getActiveObject();
    setFeatureData('activeObj', selectedObject)
    if (selectedObject.design_type == 'image') {
      changeFeature('UploadImage')
    } else if (isTextType(selectedObject.design_type)) {
      changeFeature('AddText')
    } else if (selectedObject.design_type == 'svgImage') {
      changeFeature('AddModule')
    }
  }

  //canvas物件改變或者螢幕視窗改變時，更新canvasInfo
  const updateCanvasObjsInfo = () => {
    //將非邊框的物件保留id屬性後物件化深拷貝
    tmpCanvasObjs[currentProductArea.value].designObjs = JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem).map(x => x.toObject(reserveProps))))
    tmpCanvasObjs[currentProductArea.value].center = canvas.getCenter()
    tmpCanvasObjs[currentProductArea.value].maxHeight = canvas.getHeight()
  }

  //歷史紀錄儲存資訊
  const setStepInfo = () => {
    if (stepArray.value.length && stepIndex.value && stepIndex.value == stepArray.value.length - 1) { //last step
      tmpCanvasObjs[currentProductArea.value].stepArray.push({
        designObjs: JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem).map(x => x.toObject(reserveProps)))),
        center: canvas.getCenter(),
        maxHeight: canvas.getHeight()
      })
    } else {
      tmpCanvasObjs[currentProductArea.value].stepArray.splice(stepIndex.value + 1, stepArray.value.length - 1, {
        designObjs: JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem).map(x => x.toObject(reserveProps)))),
        center: canvas.getCenter(),
        maxHeight: canvas.getHeight()
      })
    }
    //每次更新，將步驟設為當前最新
    tmpCanvasObjs[currentProductArea.value].stepIndex = tmpCanvasObjs[currentProductArea.value].stepArray.length - 1
  }

  //依螢幕寬高調整畫布大小
  const canvasResize = () => {
    canvas.setHeight(document.querySelector('#canvas_block').clientHeight);
    canvas.setWidth(document.querySelector('#canvas_block').clientWidth);
    canvas.renderAll();
  }

  //導入產品圖當背景
  const canvasBGImageSetting = () => {
    center = canvas.getCenter();
    rato.value = (canvas.getHeight() / tmpCanvasObjs[currentProductArea.value].maxHeight) //因為比例隨著高度改變，所以算出改變高度後的比例
    fabric.Image.fromURL(currentProductAreaInfo.value.image_url, oImg => {
      oImg.scaleToHeight(canvas.getHeight()); //依照高度調整比例，跟custom ink一樣

      //將背景置中
      canvas.setBackgroundImage(oImg, canvas.renderAll.bind(canvas), {
        top: center.top,
        left: center.left,
        originX: 'center',
        originY: 'center',
      });
      canvas.requestRenderAll();
    });
  }

  //產生邊界、對畫布綁上監聽事件
  const createCanvasLimit = () => {
    canvas.remove(...canvas.getObjects().filter(x => x.limitItem))
    // var areas = tmpCanvasObjs[currentProductArea.value].areaObjs.length == 0 ? currentProductAreaInfo.value.areas : tmpCanvasObjs[currentProductArea.value].areaObjs
    var areas = currentProductAreaInfo.value.areas
    let centerLineHeight=0
    if (areas.length > 0) {
      let centerLineData=null
      let centerAreaData=null
      var rato = canvas.getHeight() / currentProductAreaInfo.value.max_height //邊界不能移動，所以只針對初始高度算出比例
      areas.forEach(area => {
        let limit = new fabric.Rect({
          width: area.width * rato,
          height: area.height * rato,
          stroke: '#333333',
          strokeWidth: 1,
          top: (area.top - currentProductAreaInfo.value.center.top) * rato + center.top,
          left: (area.left - currentProductAreaInfo.value.center.left) * rato + center.left,
          // top: (area.top - tmpCanvasObjs[currentProductArea.value].center.top) * rato.value + center.top,
          // left: (area.left - tmpCanvasObjs[currentProductArea.value].center.left) * rato.value + center.left,
          selectable: false,
          fill: 'transparent',
          scaleX: area.scaleX ? area.scaleX : 1,
          scaleY: area.scaleX ? area.scaleX : 1,
          visible: false,
          limitArea: area.limit,
          limitItem: true,
          fontSize: (area.fontSize ? area.fontSize : 20) * rato,
          title: area.title
        });
        
        if (area.height * rato>centerLineHeight){
          centerLineHeight=area.height * rato
          centerAreaData={
            width: 6,
            height: area.height * rato,
            stroke: 'transparent',
            strokeWidth: 0.1,
            top: (area.top - currentProductAreaInfo.value.center.top) * rato + center.top,
            left: (area.left - currentProductAreaInfo.value.center.left) * rato +center.left+area.width * rato*0.5,
            selectable: false,
            fill: 'transparent',
            visible: true,
            limitArea: area.limit,
            limitItem: true,
            centerItem: true,
            title: area.title
          }
        }
        if (!limit.limitArea) {limit.strokeDashArray = [5, 5]}
        canvas.add(limit)

        if(area.title) {
          let text = new fabric.Text(
            area.title,
            {
              top: (area.top - currentProductAreaInfo.value.center.top) * rato + center.top,
              left: (area.left - currentProductAreaInfo.value.center.left) * rato + center.left,
              selectable: false,
              fill: '#333333',
              fontSize: (area.fontSize ? area.fontSize : 20),
              // scaleX: area.scaleX ? area.scaleX : 1,
              // scaleY: area.scaleX ? area.scaleX : 1,
              visible: false,
              limitItem: true
            }
          )
          canvas.add(text)
        }
      });
      centerLineData={
        stroke: '#333333',
        strokeWidth: 1,
        strokeDashArray: [5, 5],
        top: centerAreaData.top,
        left: centerAreaData.left,
        selectable: false,
        scaleX:  1,
        scaleY: 1,
        visible: false,
        limitItem: true,
        centerItem: true,
        centerDist: 12,
        centerAutoAlignDist: 6,
      }
      
      let centerLine = new fabric.Line([0, 0, 0, centerLineHeight],centerLineData);
      canvas.add(centerLine)


      tmpCanvasObjs[currentProductArea.value].areaObjs = JSON.parse(JSON.stringify(canvas.getObjects().filter(x => x.limitItem && x.type == 'rect').map(x => x.toObject(['limitArea', 'limitItem', 'title', 'fontSize']))))
      if (tmpCanvasObjs[currentProductArea.value].designObjs.length == 0) {
        tmpCanvasObjs[currentProductArea.value].center = canvas.getCenter()
        tmpCanvasObjs[currentProductArea.value].maxHeight = canvas.getHeight()
      }
    }

    //物件移動
    let movingLimit = (e) => {
      canvas.getObjects().filter(x => x.limitItem).forEach(element => element.visible = true)
      var centerItem = canvas.getObjects().filter(x => x.centerItem)[0]
      var adultLimit = canvas.getObjects().find(x => x.limitArea)
      var target = e.target
      var angle = target.angle
      var Radians = fabric.util.degreesToRadians(angle)
      var cos = Math.cos(Radians)
      var sin = Math.sin(Radians)
      var bound = target.getBoundingRect()
      var width = target.scaleX * target.width
      var height = target.scaleY * target.height

      var leftDistance, rightDistance, topDistance, bottomDistance
      if (angle <= 90) {
        leftDistance = height * sin
        rightDistance = width * cos
        topDistance = 0
        bottomDistance = bound.height
      } else if (90 < angle && angle <= 180) {
        leftDistance = bound.width
        rightDistance = 0
        topDistance = -(height * cos)
        bottomDistance = width * sin
      } else if (180 < angle && angle <= 270) {
        leftDistance = -(width * cos)
        rightDistance = -(height * sin)
        topDistance = bound.height
        bottomDistance = 0
      } else if (270 < angle && angle <= 360) {
        leftDistance = 0
        rightDistance = bound.width
        topDistance = -(width * sin)
        bottomDistance = height * cos
      }

      if ( target.top <= adultLimit.top + topDistance) {
        target.top = adultLimit.top + topDistance
      }
      else if ( target.top + bottomDistance > adultLimit.top + adultLimit.height) {
        target.top = adultLimit.top + adultLimit.height - bottomDistance
      }
      if (target.left <= adultLimit.left + leftDistance ) {
        target.left = adultLimit.left + leftDistance
      }
      else if (target.left + rightDistance >= adultLimit.left + adultLimit.width) {
        target.left = adultLimit.left + adultLimit.width - rightDistance
      }
      var showCenter=false
      if (Math.abs((target.left)-centerItem.left+width/2*cos-height/2*sin)<centerItem.centerDist) {
        showCenter=true
      }
      centerItem.visible = showCenter
      designLabStore.notifyDesignChanged()
    }
    //物件縮放
    let scalingLimit = (e) => {
      canvas.getObjects().filter(x => x.limitItem).forEach(element => element.visible = true)
      var adultLimit = canvas.getObjects().find(x => x.limitArea)
      var centerItem = canvas.getObjects().filter(x => x.centerItem)[0]
      var target = e.target
      var angle = target.angle
      var Radians = fabric.util.degreesToRadians(angle)
      var cos = Math.cos(Radians)
      var sin = Math.sin(Radians)

      if (!target.maxScale) {
        var leftScale, rightScale, topScale, bottomScale
        if (angle == 0) {
          rightScale = (adultLimit.left + adultLimit.width - target.left) / (target.width * cos)
          bottomScale = (adultLimit.top + adultLimit.height - target.top) / (target.width * sin + target.height * cos)
        } else if ( 0 < angle && angle <= 90) {
          rightScale = (adultLimit.left + adultLimit.width - target.left) / (target.width * cos)
          leftScale = (target.left - adultLimit.left) / (target.height * sin)
          bottomScale = (adultLimit.top + adultLimit.height - target.top) / (target.width * sin + target.height * cos)
        } else if (90 < angle && angle <= 180) {
          topScale = (target.top - adultLimit.top ) / (target.height * -cos)
          bottomScale = (adultLimit.top + adultLimit.height - target.top) / (target.width * sin)
          leftScale = (target.left - adultLimit.left) / (target.width * -cos + target.height * sin)
        } else if (180 < angle && angle <= 270) {
          leftScale = (target.left - adultLimit.left) / (target.width * -cos)
          rightScale = (adultLimit.left + adultLimit.width - target.left) / (target.height * -sin)
          topScale = (target.top - adultLimit.top ) / (target.height * -cos + target.width * -sin)
        } else if (270 < angle && angle <= 360) {
          topScale = (target.top - adultLimit.top ) / (target.width * -sin)
          bottomScale = (adultLimit.top + adultLimit.height - target.top) / (target.height * cos)
          rightScale = (adultLimit.left + adultLimit.width - target.left) / (target.height * -sin + target.width * cos)
        }

        target.maxScale = Math.min(...[leftScale, rightScale, topScale, bottomScale].filter(x => x))
      }

      if (target.scaleX >= target.maxScale || target.scaleY >= target.maxScale) {
        let threshold = 0.0;

        if(isTextType(target.design_type)) {
          // 後端演算法關係會造成一些誤差使得傳回來的文字圖片變比較小張
          // 所以扣除一點誤差
          threshold = 0.01;
        }

        target.scaleX = target.maxScale - threshold;
        target.scaleY = target.maxScale - threshold;
      }

      designLabStore.notifyDesignChanged()
    }

    //物件旋轉
    let rotatingLimit = (e) => {
      canvas.getObjects().filter(x => !x.visible).forEach(element => element.visible = true)
    }

    //滑鼠放開觸發事件
    let mouseUpHandler = async (e) => {
      if (desktopSaveMode.value) {
        return
      }
      canvas.getObjects().filter(x => x.limitItem).forEach(element => element.visible = false)

      canvas.getObjects().filter(x => x.visible).forEach(element => {
        element.maxScale = null
      })

      var target = e.target
      if (target) {
        var width = target.scaleX * target.width
        var height = target.scaleY * target.height
        var adultLimit = canvas.getObjects().find(x => x.limitArea)
        var angle = target.angle.toFixed(2)
        var bound = target.getBoundingRect()
        var preObj = tmpCanvasObjs[currentProductArea.value].designObjs.find(x => x.id == target.id)
        var isMoved = false
        var isScale = false
        if (preObj) {
          isMoved = target.top.toFixed(2) != preObj.top.toFixed(2) || target.left.toFixed(2) != preObj.left.toFixed(2)
          isScale = target.scaleX != preObj.scaleX || target.scaleY != preObj.scaleY
        }
        var Radians = fabric.util.degreesToRadians(angle)
        var cos = Math.cos(Radians)
        var sin = Math.sin(Radians)
        var centerItem =canvas.getObjects().filter(x => x.centerItem)[0]
        if (Math.abs((target.left)-centerItem.left+width/2*cos-height/2*sin)<centerItem.centerAutoAlignDist) {
          target.left = centerItem.left-width/2*cos+height/2*sin
        }
        target.imageWidth  = target.getScaledWidth().toFixed(2);
        target.imageHeight = target.getScaledHeight().toFixed(2);

        target.bound = target.getBoundingRect(true, true);
        if (preObj && target.scaleX != preObj.scaleX && isTextType(target.design_type) && preObj && angle == preObj.angle) {
          if(isVerticalText(target.design_type)) {
            const minimumWidth = (144 / canvas.getHeight()) * target.imageWidth; // 用以確保螢幕畫面為最小時（canvas高度=144）, text image依然可以正常作圖
            if(!(await isValidVerticalTextImage(target.text, target.textColor, target.font_family, target.angle, minimumWidth, target.letter_spacing))) {
              handleBacktrack();
              return;
            }
            getVerticalTextImage(target.text, target.textColor, target.font_family, target.angle, target.imageWidth, target.letter_spacing);
          } else {
            const minimumHeight = (144 / canvas.getHeight()) * target.imageHeight; // 用以確保螢幕畫面為最小時（canvas高度=144）, text image依然可以正常作圖
            if(!(await isValidTextImage(target.text, target.textColor, target.font_family, target.angle, minimumHeight))) {
              handleBacktrack();
              return;
            }
            getTextImage(target.text, target.textColor, target.font_family, target.angle, target.imageHeight) 
          }
          // target.set({
          //   scaleX: 1,
          //   scaleY: 1
          // })
        }

        if(preObj && !isTextType(target.design_type)) {
          isScale = parseFloat(preObj.imageWidth).toFixed(2) != parseFloat(target.imageWidth).toFixed(2);
        }

        if (preObj && angle != preObj.angle) {
          var rightBound  = bound.left + bound.width > adultLimit.left + adultLimit.width
          var leftBound   = bound.left < adultLimit.left
          var topBound    = bound.top < adultLimit.top
          var bottomBound = bound.top + bound.height > adultLimit.top + adultLimit.height
          if (rightBound || leftBound || topBound || bottomBound) {
            target.angle = preObj.angle
            target.top = preObj.top
            target.left = preObj.left
            target.bound = preObj.bound;
          }

          setBoundCentimeter(target)

          // tmpCanvasObjs[currentProductArea.value].designObjs = JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem)))
          updateCanvasObjsInfo()
          setStepInfo()
          designLabStore.notifyDesignChanged()
          setFeatureData('activeObj', target)
        } else if (isMoved || isScale) {
          if(isScale && !isTextType(target.design_type)) setBoundCentimeter(target)

          // tmpCanvasObjs[currentProductArea.value].designObjs = JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem)))
          updateCanvasObjsInfo()
          setStepInfo()
          designLabStore.notifyDesignChanged()
          setFeatureData('activeObj', target)
        }
      }
    }

    //刪除舊有的邊框事件
    canvas.off('object:moving');
    canvas.off('object:scaling');
    canvas.off('object:rotating');
    canvas.off('mouse:up');

    //監聽物件移動或放大時，不可超過adult範圍
    canvas.on({
      "object:moving": movingLimit,
      "object:scaling": scalingLimit,
      "object:rotating": rotatingLimit,
      "mouse:up": mouseUpHandler,
    });
  }

  const undo = async () => {
    if(loadingImage.value) return;
    if (stepIndex.value > 0) {
      tmpCanvasObjs[currentProductArea.value].stepIndex -= 1
      tmpCanvasObjs[currentProductArea.value].designObjs = stepArray.value[stepIndex.value].designObjs
      tmpCanvasObjs[currentProductArea.value].center = stepArray.value[stepIndex.value].center
      tmpCanvasObjs[currentProductArea.value].maxHeight = stepArray.value[stepIndex.value].maxHeight
    }
    // canvasResize();
    // canvasBGImageSetting();
    rato.value = (canvas.getHeight() / tmpCanvasObjs[currentProductArea.value].maxHeight)
    createCanvasLimit();
    await createAllOjects(true)
  }

  const redo = async () => {
    if(loadingImage.value) return;
    if (stepArray.value.length) {
      tmpCanvasObjs[currentProductArea.value].stepIndex += 1
      tmpCanvasObjs[currentProductArea.value].designObjs = stepArray.value[stepIndex.value].designObjs
      tmpCanvasObjs[currentProductArea.value].center = stepArray.value[stepIndex.value].center
      tmpCanvasObjs[currentProductArea.value].maxHeight = stepArray.value[stepIndex.value].maxHeight
    }
    // canvasResize();
    // canvasBGImageSetting();
    rato.value = (canvas.getHeight() / tmpCanvasObjs[currentProductArea.value].maxHeight)
    createCanvasLimit();
    await createAllOjects(true)
  }

  const loadImage = (design, index) => {
    return new Promise((resolve, reject) => {
      let image_url = design.image_url ? design.image_url : design.src
      image_url = image_url
        .replace(/([?&])height=\d+(\.\d+)?/, `$1height=${design.imageHeight * rato.value}`)
        .replace(/([?&])width=\d+(\.\d+)?/, `$1width=${design.imageWidth * rato.value}`);

      if(isTextType(design.design_type)) { // 防止text剛創建出來時不含height or width的情況
        if(isVerticalText(design.design_type)) {
          if(!image_url.includes('width')) image_url = image_url + `&width=${(design.imageWidth * rato.value)}`
        } else {
          if(!image_url.includes('height')) image_url = image_url + `&height=${(design.imageHeight * rato.value)}`
        }
      }

      fabric.Image.fromURL(image_url, (myImg) => {
        if(!myImg._element){
          reject('image not found');
          return;
        }
        
        let scale = design.scaleX ? design.scaleX : (design.imageWidth / myImg.width); // module, image

        myImg.set({
          top:             (design.top -  tmpCanvasObjs[currentProductArea.value].center.top) * rato.value + center.top,
          left:            (design.left - tmpCanvasObjs[currentProductArea.value].center.left) * rato.value + center.left,
          id:              design.id ? design.id : index + 1,
          image_id:        design?.image_id,
          imageWidth:      design?.imageWidth,
          imageHeight:     design?.imageHeight,
          bound:           design?.bound,
          scaleX:          !isTextType(design.design_type) ? scale * rato.value : 1,
          scaleY:          !isTextType(design.design_type) ? scale * rato.value : 1,
          lockScalingFlip: true,
          angle:           design.angle,
          design_type:     design.design_type,
          text:            design?.text,
          textColor:       design.color ? design?.color : design?.textColor,
          imageColors:     design.colors ? design?.colors : design?.imageColors,
          font_family:     design?.font_family,
          letter_spacing:  design?.letter_spacing,
        });
        
        resolve(myImg);
      }, { crossOrigin: 'anonymous' }); // 需要设置 crossOrigin 选项以避免跨域问题
    });
  }

  const createAllOjects = async (fromStepBtn = false) => {
    hasImageNotFound.value = false;
    canvas.remove(...canvas.getObjects().filter(x => !x.limitItem))
    var objs = tmpCanvasObjs[currentProductArea.value].designObjs.length == 0 && tmpCanvasObjs[currentProductArea.value].firstCreate ? currentProductAreaInfo.value.designs : tmpCanvasObjs[currentProductArea.value].designObjs
    if (objs.length > 0 && !loadingImage.value) { //沒在loading圖片時才能建新圖，不然會重複create
    // if (objs.length > 0 && !loadingImage.value) { //沒在loading圖片時才能建新圖，不然會重複create
      loadingImage.value = true
      var loadImageStatus = objs.map(x => false)
      for (let index = 0; index < objs.length; index++) {
        await loadImage(objs[index], index)
        .then((myImg) => {
          canvas.add(myImg);
          myImg.imageWidth  = myImg.getScaledWidth();
          myImg.imageHeight = myImg.getScaledHeight();
          myImg.bound = myImg.getBoundingRect()

          if(isTextType(myImg.design_type)) {
            const scaleX = parseFloat(objs[index].imageWidth * rato.value) / parseFloat(myImg.imageWidth);
            const scaleY = parseFloat(objs[index].imageHeight * rato.value) / parseFloat(myImg.imageHeight);

            myImg.set({
              scaleX:      1 * scaleX,
              scaleY:      1 * scaleY,
            });
            myImg.set({
              imageWidth:  parseFloat(myImg.getScaledWidth()),
              imageHeight: parseFloat(myImg.getScaledHeight()),
              bound:       myImg.getBoundingRect(true, true),
            });
          }

          setBoundCentimeter(myImg);
          
          loadImageStatus[index] = true
        })
        .catch((err) => {
          // alert(err)
          hasImageNotFound.value = true;
          console.log(err);
        })

      }
      // await Promise.all(promises);

      if (loadImageStatus.every(x => x)) {
        if (!fromStepBtn) {
          updateCanvasObjsInfo()
          // designLabStore.notifyDesignChanged()
          // 初次進頁面，如果已經有先前的設計(圖案or文字)，要把tmpCanvasObjs[currentProductArea.value].stepArray[0].designObjs換成當前產生出來的obj，因為需要有id等...的參數
          if (stepArray.value[0].designObjs.length && stepIndex.value == 0) {
            tmpCanvasObjs[currentProductArea.value].stepArray[0].designObjs = JSON.parse(JSON.stringify(canvas.getObjects().filter(x => !x.limitItem).map(x => x.toObject(reserveProps))))
            tmpCanvasObjs[currentProductArea.value].stepArray[0].center = canvas.getCenter()
            tmpCanvasObjs[currentProductArea.value].stepArray[0].maxHeight = canvas.getHeight()
          }
        }
        canvas.renderAll();
        tmpCanvasObjs[currentProductArea.value].firstCreate = false
      }
      loadingImage.value = false
    }
  }

  const createOjectByUpload = (design) => {
    fabric.Image.fromURL(design.image_url, function(myImg) {
      let limitArea = canvas.getObjects().find(x => x.limitArea);
      let scaleSize    = (design.design_type == 'image' || design.design_type == 'svgImage') ? uploadImageScale(limitArea, myImg) : 1;
      let LastId    = tmpCanvasObjs[currentProductArea.value].designObjs.length;

      myImg.set({
        top:             limitArea.top,
        left:            limitArea.left,
        id:              LastId + 1,
        image_id:        design.image_id,
        scaleX:          scaleSize,
        scaleY:          scaleSize,
        lockScalingFlip: true,
        angle:           0,
        design_type:     design.design_type,
        text:            design?.text,
        textColor:       design?.textColor,
        font_family:     design?.font_family,
        imageColors:     design?.imageColors || [],
        letter_spacing:  design?.letter_spacing,
      });

      myImg.imageWidth  = myImg.getScaledWidth();
      myImg.imageHeight = myImg.getScaledHeight();
      myImg.bound       = myImg.getBoundingRect();

      if(!checkTextObj(myImg)){
        return;
      }

      isSpecialResize.value = false;
      setBoundCentimeter(myImg);
      canvas.add(myImg);
      canvas.setActiveObject(myImg);

      updateCanvasObjsInfo();
      setStepInfo();
      initFeatureObj('uploadObj');

      designLabStore.notifyDesignChanged();
    });
  }

  const resizeCanvasObjects = () => {
    // canvas.getObjects().forEach(element => {
    canvas.getObjects().filter(x => !x.limitItem).forEach(element => {
      element.set({
        top: (element.top.toFixed(2) - tmpCanvasObjs[currentProductArea.value].center.top) * rato.value + center.top,
        left: (element.left.toFixed(2) - tmpCanvasObjs[currentProductArea.value].center.left) * rato.value + center.left,
        scaleX: element.scaleX * rato.value,
        scaleY: element.scaleY * rato.value,
      })
      element.setCoords();
    });
    canvas.requestRenderAll();

    updateCanvasObjsInfo()
    setStepInfo(true)
  }

  const changeArea = (title) => {
    if(!loadingImage.value) {
      currentProductArea.value = title
    }
  }

  const cancelActiveObj = () => {
    canvas.discardActiveObject().renderAll();
  }

  const desktopSubmit = (value = false) => {
    if(loadingImage.value) return;
    const violationArea = validatePrintAreaMinSize();
    if(violationArea.length != 0) {
      swal({
        title: "印刷區域提示",
        text: `[${violationArea.join('、')}]的印製範圍任一邊長必須大於或等於0.1cm，請修改後再提交，謝謝\n`,
        buttons: {
          confirm: { 
            text: "Ok",
            visible: true,
            value: true
          }
        },
        dangerMode: true,
        closeOnClickOutside: false
      })
      return;
    }

    designLabStore.activeSetup(value, null)
    cancelActiveObj()
    updateCanvasObjsInfo()
    // designLabStore.notifyDesignChanged()
    Object.keys(tmpCanvasObjs).forEach(area => {
      if (tmpCanvasObjs[area].stepArray[tmpCanvasObjs[area].stepIndex].designObjs.length != 0) {
        tmpCanvasObjs[area].stepArray.splice(0, tmpCanvasObjs[area].stepArray.length, tmpCanvasObjs[area].stepArray[tmpCanvasObjs[area].stepArray.length - 1])
        tmpCanvasObjs[area].stepIndex = 0
      }
    })
  }

  const clearCanvas = () => {
    if(canvas.getObjects().filter(x => !x.limitItem).length) {
      canvas.remove(...canvas.getObjects().filter(x => !x.limitItem))
      updateCanvasObjsInfo()
      setStepInfo()
      console.log(tmpCanvasObjs)
      Object.keys(tmpCanvasObjs).forEach(area => {
        tmpCanvasObjs[area].designObjs = []
        console.log(tmpCanvasObjs[area].stepArray[tmpCanvasObjs[area].stepIndex].designObjs.length)
        if (tmpCanvasObjs[area].stepArray[tmpCanvasObjs[area].stepIndex].designObjs.length != 0) {
          //如果其它區域存在設計
          tmpCanvasObjs[area].stepArray.push({
            designObjs: [],
            center: tmpCanvasObjs[area].center,
            maxHeight: tmpCanvasObjs[area].maxHeight
          })
          tmpCanvasObjs[area].stepIndex += 1
        }
      })
      designLabStore.notifyDesignChanged()
    }
  }

  onMounted(async () => {
    window.onresize = () => {
      screenWidth.value = document.body.clientWidth
      screenHeight.value = document.body.clientHeight
      var hhh = document.querySelector('.header').offsetHeight
    }

    const mediaQueryList = window.matchMedia('(max-width: 768px)');
    changeIsMobile(mediaQueryList.matches);

    // 添加媒体查询变化的事件监听器
    const handleMediaQueryChange = (event) => {
      changeIsMobile(event.matches);
    };
    mediaQueryList.addListener(handleMediaQueryChange);

    // 設定design lab
    init();
    await designLabStore.init(props.designId, props.designMode, props.designVgId);
    if(props.designMaterialId) getModule(props.designMaterialId);
  })

  //
  watch(
    ProductInfo,
    async () => {
      designLabStore.setDesignLabLoading(true);
      getProductLimitInfo();
      canvasResize();
      canvasBGImageSetting();
      createCanvasLimit();
      await createAllOjects();
      designLabStore.setDesignLabLoading(false);
      changeMaxWidth(Math.floor(canvas.getObjects().find(x => x.limitItem && x.limitArea)?.width));
      if (desktopSaveMode.value) {
        canvas.selection = false;
        canvas.hoverCursor = 'default';
        // canvas.defaultCursor = 'default';
        canvas.forEachObject(function(obj) {
          obj.selectable = false;
        });
      }
    }
  );

  watch([screenWidth, screenHeight], Debounce(async () => {
    canvasResize()
    canvasBGImageSetting()
    createCanvasLimit()
    // resizeCanvasObjects()
    changeMaxWidth(Math.floor(canvas.getObjects().find(x => x.limitItem && x.limitArea)?.width));
    await createAllOjects()
    if (desktopSaveMode.value) {
      canvas.selection = false;
      canvas.hoverCursor = 'default';
      // canvas.defaultCursor = 'default';
      canvas.forEachObject(function(obj) {
        obj.selectable = false;
      });
    }
  },100))

  watch(currentProductArea, (n, o) => {
    if (o != '') { //getProductLimitInfo會跑到這裡一次，防止一開始多執行一次createCanvasLimit
      canvasBGImageSetting()
      createCanvasLimit()
      changeMaxWidth(Math.floor(canvas.getObjects().find(x => x.limitItem && x.limitArea)?.width));
      createAllOjects()
    }
  })

  watch(showAreaOptions, (n) => {
    if (n) {
      document.addEventListener("click", closeAreaBlock)
      document.addEventListener("touchend", closeAreaBlock)
    } else {
      document.removeEventListener("click", closeAreaBlock);
      document.removeEventListener("touchend", closeAreaBlock);
    }
  })

  watch(()=>featureData.variantId, (n, o) => {
    designLabStore.setDesignLabLoading(true);
    var currentSpecColor = specColors.value.find(x => x.variant_id == n);

    // 替換顏色後

    // 替換variant ID
    ProductInfo.value.variant_id = n;

    // 更換design的底圖資料
    currentSpecColor?.moks.forEach(element => {
      ProductInfo.value.moks.find(x => x.side_id == element.side_id).image_url = element.image_url;
    });

    // 更換design的顏色資料
    ProductInfo.value.color.name = currentSpecColor.description;
    ProductInfo.value.color.code = currentSpecColor.value;

    // 設計搞確認的預覽圖需要重新跑
    // 如果值為NaN時，代表第一次進入design lab
    // 第一次進入design lab時design沒有改變，所以不用觸發notifyDesignChanged
    if(o) {
      designLabStore.notifyDesignChanged()
    }

    // 重新設定canvas底圖
    canvasBGImageSetting();
    designLabStore.setDesignLabLoading(false);
  })

  watch(() => featureData.featureId, (n) => {
    if (n) {
      var currentFeature = features.find(x => x.id == n)
      componentName.value = currentFeature.component
    } else {
      canvas.discardActiveObject().renderAll();
    }
  });

  const setTextObjAttribures = (canvasObject, data, originWidth, originHeight) => {
    if(!isTextType(canvasObject.design_type)) {
      return;
    }

    const isCalibrate =  canvasObject.text == data.text && !isSpecialResize.value
    canvasObject.set({
      text:        data.text,
      textColor:   data.textColor,
      font_family: data.font_family,
      scaleX:      1,
      scaleY:      1,
      angle:       canvasObject.angle,
      letter_spacing: data.letter_spacing,
    });

    canvasObject.set({
      imageWidth:  parseFloat(canvasObject.getScaledWidth()),
      imageHeight: parseFloat(canvasObject.getScaledHeight()),
      bound:       canvasObject.getBoundingRect(true, true),
    });

    if(isCalibrate) {
      const calibrationScaleX = originWidth / canvasObject.getScaledWidth();
      const calibrationScaleY = originHeight / canvasObject.getScaledHeight();
      
      canvasObject.set({
        scaleX:      1 * calibrationScaleX,
        scaleY:      1 * calibrationScaleY,
      });
      canvasObject.set({
        imageWidth:  parseFloat(canvasObject.getScaledWidth()),
        imageHeight: parseFloat(canvasObject.getScaledHeight()),
        bound:       canvasObject.getBoundingRect(true, true),
      });
    }
    isSpecialResize.value = false;
  };

  const resetCanvasObjPosition = (canvasObject) => {
    const limitArea = canvas.getObjects().find(x => x.limitArea);

    const areaX = limitArea.left + limitArea.width;
    const areaY = limitArea.top + limitArea.height;

    const objX = canvasObject.bound.left + canvasObject.bound.width;
    const objY = canvasObject.bound.top + canvasObject.bound.height;

    const dx = objX - areaX;
    const dy = objY - areaY;
    if(dx > 0){
      canvasObject.left = canvasObject.left - dx;
    }

    if(dy > 0){
      canvasObject.top = canvasObject.top - dy;
    }
  };

  const checkObjSize = (canvasObject) => {
    const limitArea = canvas.getObjects().find(x => x.limitArea);

    if (limitArea.width < canvasObject.bound.width || limitArea.height < canvasObject.bound.height){
      return false;
    }

    return true;
  };

  const recalcTextObjHeight = (canvasObject) => {
    let imageHeight = canvasObject.imageHeight;

    if(!checkObjSize(canvasObject)){
      const limitArea = canvas.getObjects().find(x => x.limitArea);

      const threshold = 0.03;
      const wRatio    = limitArea.width / canvasObject.bound.width;
      const hRaito    = limitArea.height / canvasObject.bound.height;

      console.log("raw height", imageHeight);
      console.log("width===", limitArea.width, canvasObject.bound.width);
      console.log("ratio===", wRatio - threshold, hRaito - threshold);
      imageHeight = Math.floor(imageHeight * Math.min(wRatio - threshold, hRaito - threshold));
      console.log("new height", imageHeight);

      isSpecialResize.value = true;
    }

    return imageHeight;
  };

  const recalcTextObjWidth = (canvasObject) => {
    let imageWidth = canvasObject.imageWidth;

    if(!checkObjSize(canvasObject)){
      const limitArea = canvas.getObjects().find(x => x.limitArea);

      const threshold = 0.03;
      const wRatio    = limitArea.width / canvasObject.bound.width;
      const hRaito    = limitArea.height / canvasObject.bound.height;

      console.log("raw width", imageWidth);
      console.log("width===", limitArea.width, canvasObject.bound.width);
      console.log("ratio===", wRatio - threshold, hRaito - threshold);
      imageWidth = Math.floor(imageWidth * Math.min(wRatio - threshold, hRaito - threshold));
      console.log("new width", imageWidth);

      isSpecialResize.value = true;
    }

    return imageWidth;
  };

  // 文字圖片太大，重新計算適當尺寸並重新取得文字圖片
  const checkTextObj = (obj)=> {
    if(!isTextType(obj.design_type)){
      return true;
    }

    if(checkObjSize(obj)){
      return true;
    }


    if(isVerticalText(obj.design_type)) {
      getVerticalTextImage(
        obj.text,
        obj.textColor,
        obj.font_family,
        obj.angle,
        recalcTextObjWidth(obj),
        obj.letter_spacing
      );
    } else {
      getTextImage(
        obj.text,
        obj.textColor,
        obj.font_family,
        obj.angle,
        recalcTextObjHeight(obj)
      );
    }
  };

  const uploadImageScale = (limit, item) => {
    return Math.min(limit.width / 3.0 / item.width, limit.height / 2.0 / item.height);
  }

  const setBoundCentimeter = (targetObj) => { 
    targetObj.boundWidthCm  = centimeterConvert(targetObj.bound.width);
    targetObj.boundHeightCm = centimeterConvert(targetObj.bound.height);
    targetObj.inputWidthCm  = targetObj.boundWidthCm.toFixed(1);
    targetObj.inputHeightCm = targetObj.boundHeightCm.toFixed(1);
  }

  const centimeterConvert = (lengthPixel) => {
    const currentArea       = originalDesignAreas.value.find(x => x.title == currentProductArea.value);
    const currentScaleRatio = canvas.getHeight() / currentArea.originalMaxHeight;
    const originLengthPixel = lengthPixel / currentScaleRatio;
    const centimeter        = originLengthPixel / ProductInfo.value.px_per_cm;
    return centimeter;
  }

  const alignActiveObjCenter = (fabricActiveObj, options = null) => {
    if(!options) return;
    const w = fabricActiveObj.scaleX * fabricActiveObj.width;
    const h = fabricActiveObj.scaleY * fabricActiveObj.height;
    const angle = fabricActiveObj.angle.toFixed(2);
    const cos = Math.cos(fabric.util.degreesToRadians(angle));
    const sin = Math.sin(fabric.util.degreesToRadians(angle));

    switch(options.method) {
      case "center":
        const centerItem = canvas.getObjects().filter(x => x.centerItem)[0];
        fabricActiveObj.left  = centerItem.left - (w / 2 * cos) + (h / 2 * sin);
        fabricActiveObj.bound = fabricActiveObj.getBoundingRect(true, true);
        break;
      default:
        break;
    }
    
    canvas.renderAll();
    updateCanvasObjsInfo()
    setStepInfo()
    designLabStore.notifyDesignChanged()
    setFeatureData('activeObj', fabricActiveObj);
  }

  const resizeActiveObj = async (fabricActiveObj, options = nil) => { 
    if(!options) return;
    const originalScaleX = fabricActiveObj.scaleX;
    const originalScaleY = fabricActiveObj.scaleY;
    const limit          = canvas.getObjects().find(x => x.limitArea);
    let newSideValue     = options.newSideValue;
    let scaleRatio       = 1.0;

    if(newSideValue <= 0) newSideValue = 0.1

    if(options.side == 'width') {
      scaleRatio = newSideValue / fabricActiveObj.boundWidthCm;
    } else if(options.side == 'height') {
      scaleRatio = newSideValue / fabricActiveObj.boundHeightCm;
    }

    // resize and recalculate bound;
    fabricActiveObj.set({
      scaleX: originalScaleX * scaleRatio,
      scaleY: originalScaleY * scaleRatio,
    });
   
    fabricActiveObj.setCoords();
    let bound = fabricActiveObj.getBoundingRect();

    // if widht or height too large, resize again
    if(bound.width > limit.width || bound.height > limit.height) { 
      scaleRatio = Math.min(limit.width / fabricActiveObj.bound.width, limit.height / fabricActiveObj.bound.height)
      fabricActiveObj.set({
        scaleX: originalScaleX * scaleRatio,
        scaleY: originalScaleY * scaleRatio,
      })
    }

    fabricActiveObj.set({
      imageWidth  : fabricActiveObj.getScaledWidth(),
      imageHeight : fabricActiveObj.getScaledHeight(),
    })
    
    fabricActiveObj.setCoords();
    bound = fabricActiveObj.getBoundingRect();

    fabricActiveObj.bound = bound;

    // handle exceed limit, modify position
    const isExceedTop    = bound.top < limit.top;
    const isExceedRight  = bound.left + bound.width > limit.left + limit.width;
    const isExceedBottom = bound.top + bound.height > limit.top + limit.height;
    const isExceedLeft   = bound.left < limit.left;

    if(isExceedTop) {
      const modifiedTop = limit.top;
      const diffY = modifiedTop - bound.top;
      fabricActiveObj.bound.top = modifiedTop;
      fabricActiveObj.top = fabricActiveObj.top + diffY;
    }

    if(isExceedRight) {
      const modifiedLeft = limit.left + limit.width - bound.width;
      const diffX = modifiedLeft - bound.left;
      fabricActiveObj.bound.left = modifiedLeft;
      fabricActiveObj.left = fabricActiveObj.left + diffX;
    }

    if(isExceedBottom) {
      const modifiedTop = limit.top + limit.height - bound.height;
      const diffY = modifiedTop - bound.top;
      fabricActiveObj.bound.top = modifiedTop;
      fabricActiveObj.top = fabricActiveObj.top + diffY;
    }

    if(isExceedLeft) {
      const modifiedLeft = limit.left;
      const diffX = modifiedLeft - bound.left;
      fabricActiveObj.bound.left = modifiedLeft;
      fabricActiveObj.left = fabricActiveObj.left + diffX;
    }

    if(options.isText) {
      loadingImage.value = true;
      if(options.isVertical) {
        const minimumWidth = (144 / canvas.getHeight()) *  fabricActiveObj.getScaledWidth(); // 用以確保螢幕畫面為最小時（canvas高度=144）, text image依然可以正常作圖
        if(!(await isValidVerticalTextImage(options.currentText, options.curretTextColor, options.currentFontFamily, featureData.activeObj.angle, minimumWidth, featureData.activeObj.letter_spacing))) {
          loadingImage.value = false;
          handleBacktrack();
          return;
        }
        getVerticalTextImage(options.currentText, options.curretTextColor, options.currentFontFamily, featureData.activeObj.angle, fabricActiveObj.getScaledWidth(), fabricActiveObj.letter_spacing);
      } else {
        const minimumHeight = (144 / canvas.getHeight()) * fabricActiveObj.getScaledHeight(); // 用以確保螢幕畫面為最小時（canvas高度=144）, text image依然可以正常作圖
        if(!(await isValidTextImage(options.currentText, options.curretTextColor, options.currentFontFamily, featureData.activeObj.angle, minimumHeight))) {
          loadingImage.value = false;
          handleBacktrack();
          return;
        }
        getTextImage(options.currentText, options.curretTextColor, options.currentFontFamily, featureData.activeObj.angle, fabricActiveObj.getScaledHeight());
      }
    } else {
      setBoundCentimeter(fabricActiveObj);
      canvas.renderAll();
      updateCanvasObjsInfo();
      setStepInfo();
      designLabStore.notifyDesignChanged()
      setFeatureData('activeObj', fabricActiveObj);
    }
  }

  const validatePrintAreaMinSize = () => {
    const mokCollection = ProductInfo.value.moks;
    const violationArea = [];
    
    mokCollection.forEach((mok) => {
      const objectArray = tmpCanvasObjs[mok.title]?.designObjs || [];
      
      if(objectArray.length == 0) return;
      
      // Initialize variables to calculate min/max values
      let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      
      objectArray.forEach(({ bound }) => {
        minX = Math.min(minX, bound.left, bound.left + bound.width);
        minY = Math.min(minY, bound.top, bound.top + bound.height);
        maxX = Math.max(maxX, bound.left, bound.left + bound.width);
        maxY = Math.max(maxY, bound.top, bound.top + bound.height);
      });

      const mokAreaWidhtCm  = centimeterConvert((maxX - minX));
      const mokAreaHeightCm = centimeterConvert((maxY - minY));

      if(parseFloat(mokAreaWidhtCm.toFixed(1)) < 0.1 || parseFloat(mokAreaHeightCm.toFixed(1)) < 0.1) {
        violationArea.push(mok.title)
      }
    });

    return violationArea;
  }

  const handleBacktrack = async () => {
    await undo();
    await redo();
    swal({
      title: "文字模板提示",
      text: `無法支援寬度或高度過小的文字內容`,
      buttons: {
        confirm: { 
          text: "Ok",
          visible: true,
          value: true
        }
      },
      dangerMode: true,
      closeOnClickOutside: false
    })
  }

  const handleHasImageNotFound = () => {
    swal({
      title: "印刷區域提示",
      text: `畫布過小導致部份設計無法正常顯示, 請調整螢幕方向確認設計後再繼續操作，謝謝\n`,
      buttons: {
        confirm: { 
          text: "Ok",
          visible: true,
          value: true
        }
      },
      dangerMode: true,
      closeOnClickOutside: false
    })
  }

  watch(() => featureData.uploadObj.image_url, (n) => {
    if(!n) {
      return;
    }

    // Flip行為的特殊處理 (目前僅有文字)
    if (pendingFlip.value) {
      const flipData = pendingFlip.value;
      const selectedObject = canvas.getActiveObject();

      if (!selectedObject || selectedObject.id !== flipData.targetId) {
        pendingFlip.value = null;
        loadingImage.value = false;
        return;
      }

      selectedObject.setSrc(n, () => {
        const limitArea = canvas.getObjects().find(x => x.limitArea);
        selectedObject.set({
          // 像 createOjectByUpload 一樣重設
          top: limitArea.top,
          left: limitArea.left,
          scaleX: 1,
          scaleY: 1,
          angle: 0,
          design_type: flipData.designType,
          text: flipData.text,
          textColor: flipData.textColor,
          font_family: flipData.fontFamily,
          letter_spacing: flipData.letterSpacing
        });

        selectedObject.setCoords();

        selectedObject.set({
          imageWidth: parseFloat(selectedObject.getScaledWidth()),
          imageHeight: parseFloat(selectedObject.getScaledHeight()),
          bound: selectedObject.getBoundingRect()
        });
       
        selectedObject.setCoords();

        if(!checkTextObj(selectedObject)){
          return;
        }

        isSpecialResize.value = false;
        setBoundCentimeter(selectedObject);

        canvas.renderAll();

        updateCanvasObjsInfo();
        setStepInfo();
        designLabStore.notifyDesignChanged();

        setFeatureData("activeObj", selectedObject);
        initFeatureObj("uploadObj");

        pendingFlip.value = null;
        loadingImage.value = false;
      });

      return;
    }

    // Spacing行為的特殊處理 (目前僅有vertical文字)
    if (pendingSpacing.value) {
      const spacingData = pendingSpacing.value;
      const selectedObject = canvas.getActiveObject();

      if (!selectedObject || selectedObject.id !== spacingData.targetId) {
        pendingSpacing.value = null;
        loadingImage.value = false;
        return;
      }

      selectedObject.setSrc(n, () => {
        selectedObject.set({
          letter_spacing: spacingData.letterSpacing
        });

        selectedObject.setCoords();

        selectedObject.set({
          imageWidth: parseFloat(selectedObject.getScaledWidth()),
          imageHeight: parseFloat(selectedObject.getScaledHeight()),
          bound: selectedObject.getBoundingRect()
        });
       
        selectedObject.setCoords();

        const limit = canvas.getObjects().find(x => x.limitArea);
        let bound = selectedObject.getBoundingRect(true, true);

        const isExceedTop    = bound.top < limit.top;
        const isExceedRight  = bound.left + bound.width > limit.left + limit.width;
        const isExceedBottom = bound.top + bound.height > limit.top + limit.height;
        const isExceedLeft   = bound.left < limit.left;

        if(isExceedTop) {
          const modifiedTop = limit.top;
          const diffY = modifiedTop - bound.top;
          selectedObject.bound.top = modifiedTop;
          selectedObject.top = selectedObject.top + diffY;
        }

        if(isExceedRight) {
          const modifiedLeft = limit.left + limit.width - bound.width;
          const diffX = modifiedLeft - bound.left;
          selectedObject.bound.left = modifiedLeft;
          selectedObject.left = selectedObject.left + diffX;
        }

        if(isExceedBottom) {
          const modifiedTop = limit.top + limit.height - bound.height;
          const diffY = modifiedTop - bound.top;
          selectedObject.bound.top = modifiedTop;
          selectedObject.top = selectedObject.top + diffY;
        }

        if(isExceedLeft) {
          const modifiedLeft = limit.left;
          const diffX = modifiedLeft - bound.left;
          selectedObject.bound.left = modifiedLeft;
          selectedObject.left = selectedObject.left + diffX;
        }

        selectedObject.setCoords();

        selectedObject.set({
          imageWidth: parseFloat(selectedObject.getScaledWidth()),
          imageHeight: parseFloat(selectedObject.getScaledHeight()),
          bound: selectedObject.getBoundingRect(true, true)
        });

        if(!checkTextObj(selectedObject)){
          return;
        }

        isSpecialResize.value = false;
        setBoundCentimeter(selectedObject);

        canvas.renderAll();

        updateCanvasObjsInfo();
        setStepInfo();
        designLabStore.notifyDesignChanged();

        setFeatureData("activeObj", selectedObject);
        initFeatureObj("uploadObj");

        pendingSpacing.value = null;
        loadingImage.value = false;
      });

      return;
    }
    
    // 上傳新的圖片或文字圖片
    if (!featureData.activeObj.id || (!isTextType(featureData.activeObj.design_type) && featureData.activeObj.design_type != 'svgImage')) {
      createOjectByUpload(featureData.uploadObj);
      return;
    }

    if(isTextType(featureData.activeObj.design_type)) {  // 重新渲染目前編輯的文字
      let selectedObject = canvas.getActiveObject();
      if (selectedObject.id != featureData.activeObj.id) {
        return;
      }
      const ow = selectedObject.getScaledWidth();
      const oh = selectedObject.getScaledHeight();
      selectedObject.setSrc(n, () => {
        const textData = featureData.uploadObj;
        setTextObjAttribures(selectedObject, textData, ow, oh);
        if(!checkTextObj(selectedObject)){
          return;
        }

        resetCanvasObjPosition(selectedObject);
        setBoundCentimeter(selectedObject);
        featureData.activeObj.boundWidthCm  = selectedObject.boundWidthCm;
        featureData.activeObj.boundHeightCm = selectedObject.boundHeightCm;
        featureData.activeObj.inputWidthCm  = selectedObject.inputWidthCm;
        featureData.activeObj.inputHeightCm = selectedObject.inputHeightCm;
        canvas.renderAll();
        updateCanvasObjsInfo();
        setStepInfo();
        designLabStore.notifyDesignChanged();
        // bug repair
        setFeatureData("activeObj", selectedObject);
        initFeatureObj('uploadObj');
        loadingImage.value = false;
      });
    } else if(featureData.activeObj.design_type == 'svgImage') {  // 重新渲染目前編輯的module
      let selectedObject = canvas.getActiveObject();
      
      if (selectedObject.id != featureData.activeObj.id) {
        return;
      }
      
      selectedObject.setSrc(n, () =>  {
        const imageData = JSON.parse(JSON.stringify(featureData.uploadObj));
        selectedObject.set({
          imageColors: imageData.imageColors
        });
        canvas.renderAll();
        updateCanvasObjsInfo();
        setStepInfo();
        designLabStore.notifyDesignChanged();
        moduleColorLock.value = false;
        initFeatureObj('uploadObj');
      });
    }
  });

  watch(() => panelOperationEvent, (newV) => {
    if(newV.event === "") return;
   
    const fabricActiveObj = canvas.getActiveObject(); 
    if(!fabricActiveObj) {
      panelOperationEvent.event = ""
      panelOperationEvent.options = {}
      return;
    }

    if(newV.event == "align") {
      alignActiveObjCenter(fabricActiveObj, newV.options);
    } else if(newV.event == "resize") {
      resizeActiveObj(fabricActiveObj, newV.options)
    } else if(newV.event == "flip") {
      if (!isTextType(fabricActiveObj.design_type) || !isTextType(newV.options.designType)) return;

      pendingFlip.value = {
        targetId: fabricActiveObj.id,
        designType: newV.options.designType,
        text: newV.options.currentText,
        textColor: newV.options.curretTextColor,
        fontFamily: newV.options.currentFontFamily,
        letterSpacing: isVerticalText(newV.options.designType) ? 0 : null
      };

      fabricActiveObj.set({
        design_type: newV.options.designType
      });

      loadingImage.value = true;

      isVerticalText(newV.options.designType) ? 
        getVerticalTextImage(newV.options.currentText, newV.options.curretTextColor, newV.options.currentFontFamily): 
        getTextImage(newV.options.currentText, newV.options.curretTextColor, newV.options.currentFontFamily);
    } else if(newV.event == "spacing") {
      if (!isVerticalText(fabricActiveObj.design_type)) return;

      pendingSpacing.value = {
        targetId: fabricActiveObj.id,
        letterSpacing: newV.options.letterSpacing,
      };

      loadingImage.value = true;
      
      getVerticalTextImage(newV.options.currentText, newV.options.curretTextColor, newV.options.currentFontFamily, newV.options.angle, newV.options.imageWidth, newV.options.letterSpacing)
    }
    
    panelOperationEvent.event = ""
    panelOperationEvent.options = {}
  }, {deep: true})

  //按下提交按鈕後，暫時無法修改設計
  watch(desktopSaveMode, (n) => {
    if(n) {
      canvas.selection = false;
      canvas.hoverCursor = 'default';
      // canvas.defaultCursor = 'default';
      canvas.forEachObject(function(obj) {
        obj.selectable = false;
      });
    } else {
      canvas.selection = true;
      canvas.hoverCursor = 'move';
      canvas.forEachObject(function(obj) {
        obj.selectable = true;
      });
    }
  })

  onUnmounted(() => {
    document.removeEventListener("click", closeAreaBlock);
    document.removeEventListener("touchend", closeAreaBlock);
  })

</script>

<style>
button {
  font-weight: bold;
}
</style>../components/setups/DesignShoppingCart.vue/index.js
